import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SpinnerComponent } from './common/spinner/spinner.component';
import { SchedularListViewComponent } from './common/schedular-list-view/schedular-list-view.component';
import { SharedMeetingManagerModule } from '../shared-meeting-manager/shared-meeting-manager.module';
import { SafeHtmlPipe, SafeHtmlURLPipe } from './common/pipes/safe-html.pipe';
import { ClickOutsideDirective } from './common/directives/click-outside.directive';
import { NoWhitespaceDirective } from './common/directives/no-whitespace.directive';
import { WINDOW_PROVIDERS } from './services/window-ref.service';
import { MeetingTypeSelectionComponent } from "./common/meeting-type-selection/meeting-type-selection.component";
import { BackToTopComponent } from './common/back-to-top/back-to-top.component';
import { DialogComponent } from './common/dialog/dialog.component';
import { ForgeComponents } from 'app/forge-components';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        SharedMeetingManagerModule,
        ForgeComponents
    ],
    declarations: [
        SpinnerComponent,
        SchedularListViewComponent,
        SafeHtmlPipe,
        ClickOutsideDirective,
        NoWhitespaceDirective,
        SafeHtmlURLPipe,
        MeetingTypeSelectionComponent,
        BackToTopComponent,
        DialogComponent
    ],
    exports: [
        CommonModule,
        FormsModule,
        RouterModule,
        SpinnerComponent,
        SchedularListViewComponent,
        SafeHtmlPipe,
        ClickOutsideDirective,
        NoWhitespaceDirective,
        SafeHtmlURLPipe,
        MeetingTypeSelectionComponent,
        BackToTopComponent,
        DialogComponent
    ],
    providers: [
        WINDOW_PROVIDERS
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {
}
